export default __webpack_public_path__ + "static/media/monthly_pass_selected.9e95b8d6.png";